import React, { useCallback } from 'react';
import clsx from 'clsx';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectActiveMenuItem, setActiveMenuItem, setSelectedGroupId } from '../../redux/slices/form-builder-slice';
import { useUser } from '@myosh/myosh-login';

const navigationItems = [
  'Fields',
  'Workflow',
  'Record List',
  'Calendar',
  'Notification',
  'AI',
  'Access Control',
  'Advanced',
];

const FormBuilderSidebarMenu = () => {
  const dispatch = useAppDispatch();

  const activeMenuItem = useAppSelector(selectActiveMenuItem);
  const {
    state: { user },
  } = useUser();
  const isSuperuser = user?.superuser === 'true';

  const filteredNavigationItems = isSuperuser ? navigationItems : navigationItems.filter((item) => item !== 'AI');

  const onMenuItemClicked = useCallback(
    (label: string) => {
      dispatch(setActiveMenuItem(label));
      dispatch(setSelectedGroupId(undefined)); // Reset selected group when changing menu
    },
    [dispatch]
  );

  return (
    <div className="flex flex-col shrink-0 border-r border-gray-4 w-44">
      {filteredNavigationItems.map((menuItem) => {
        return (
          <SidebarMenuItem
            key={menuItem}
            label={menuItem}
            isActive={activeMenuItem === menuItem}
            onClick={onMenuItemClicked}
          />
        );
      })}
    </div>
  );
};

export default React.memo(FormBuilderSidebarMenu);

// Sidebar Menu Item Component

const SidebarMenuItem = React.memo(MenuItem);
interface MenuItemProps {
  label: string;
  isActive: boolean;
  onClick: (label: string) => void;
}

function MenuItem({ label, isActive, onClick }: MenuItemProps) {
  const menuItemsWrapperStyling = clsx(
    'flex items-center transition-colors duration-300 border-l-4 border-transparent hover:bg-primary-4 hover:cursor-pointer dark:hover:bg-gray-3 relative',
    {
      'bg-primary-5 !border-primary-1 text-primary-1 font-semibold hover:!bg-primary-5': isActive,
    }
  );

  const handleClick = useCallback(() => onClick(label), [label, onClick]);

  return (
    <div className={menuItemsWrapperStyling} onClick={handleClick}>
      <span className="mr-auto ml-2 py-2 leading-5 text-sm truncate transition-opacity duration-300">{label}</span>
    </div>
  );
}
